<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')" disable-backdrop-click>
    <template #default>
      <div class="rounded shadow-xs w-full max-w-3xl mx-auto" @click.stop>
        <div class="rounded shadow-lg bg-white overflow-hidden">
          <div class="h-10 bg-white pl-4">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Manage reviews</h1>
              </div>
              <div class="flex-none">
                <button
                  class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                  @click="$refs.modal.close()"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                    <path
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-12 bg-gray-100 space-y-6">
            <Loader v-if="loading" />
            <ul v-else class="space-y-8">
              <li
                v-for="approvalRequestId in projectAsset.approvalRequests || []"
                :key="approvalRequestId"
              >
                <ApprovalRequestLine
                  :can-send-approval-request="canSendApprovalRequest"
                  :approval-request-id="approvalRequestId"
                  @updated="readProjectAsset"
                  @approval-request-rejected="handleApprovalRequestRejected"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import ApprovalRequestLine from './editAssetModal/ApprovalRequestLine.vue';

export default {
  name: 'ManageAssetReviewsModal',
  components: {
    ApprovalRequestLine,
  },
  props: {
    projectAssetId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    projectAsset() {
      return this.$store.state.entities.projectAssets.byId[this.projectAssetId] || null;
    },
    project() {
      if (!this.projectAsset) return null;

      return this.$store.state.entities.projects.byId[this.projectAsset.projectId] || null;
    },
    canSendApprovalRequest() {
      if (this.$isAdminOrSuperAdmin) {
        return true;
      }

      if (!this.project) {
        return false;
      }

      if (this.project.ownerId === this.$user.id) {
        return true;
      }

      return false;
    },
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      try {
        this.loading = true;
        await this.readProjectAsset();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async readProjectAsset() {
      try {
        await this.$store.dispatch({
          type: 'ui/projectAssets/read',
          projectAssetId: this.projectAssetId,
          params: {
            include: [
              'asset',
              'approvalRequests.comments',
              'reviewers',
              'approvalRequestsCount',
              'approvedApprovalRequestsCount',
              'rejectedApprovalRequestsCount',
              'pendingApprovalRequestsCount',
              'pendingApprovalRequest',
            ].join(','),
          },
        });
      } catch (error) {
        //
      }
    },
    handleApprovalRequestRejected(approvalRequest) {
      this.$emit('approval-request-rejected', approvalRequest);
    },
  },
};
</script>
